import { Toast, ToastProvider, ToastViewport } from "@radix-ui/react-toast";
import { ReactNode } from "react";

interface ToasterProps {
  children?: ReactNode;
}

export function Toaster({ children }: ToasterProps) {
  return (
    <ToastProvider>
      {children}
      <ToastViewport className="fixed bottom-0 right-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:flex-col md:max-w-[420px]" />
    </ToastProvider>
  );
}

// TODO: When implementing user feedback, create these additional components:
//
// 1. Toast hook for easier usage:
// export function useToast() {
//   // Implementation for programmatic toast triggering
// }
//
// 2. Toast variants for different states:
// - ToastSuccess (green theme)
// - ToastError (red theme)
// - ToastWarning (yellow theme)
// - ToastInfo (blue theme)
//
// 3. Pre-built toast functions:
// export const toast = {
//   success: (message: string) => { /* show success toast */ },
//   error: (message: string) => { /* show error toast */ },
//   warning: (message: string) => { /* show warning toast */ },
//   info: (message: string) => { /* show info toast */ },
// };

export { Toast };
